"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.init = exports.updateAccess = exports.access = exports.backwardBtn = exports.forwardBtn = void 0;
var Buttons = (function () {
    function Buttons(direction) {
        var e_1, _a;
        this.direction = direction;
        this.span = Buttons.createElement('btns');
        this.f = Buttons.createElement('btn f', this.direction + ' ' + 'element');
        this.ff = Buttons.createElement('btn ff', this.direction + ' ' + 'unchanged element');
        this.fff = Buttons.createElement('btn fff', this.direction + ' ' + 'unviewed element');
        this.span.id = direction;
        var order = direction === 'next' ? [this.f, this.ff, this.fff] :
            [this.fff, this.ff, this.f];
        try {
            for (var order_1 = __values(order), order_1_1 = order_1.next(); !order_1_1.done; order_1_1 = order_1.next()) {
                var span = order_1_1.value;
                span.classList.add(direction);
                span.setAttribute('tabindex', '0');
                this.span.appendChild(span);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (order_1_1 && !order_1_1.done && (_a = order_1.return)) _a.call(order_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.hide();
    }
    Buttons.createElement = function (cls, title) {
        if (title === void 0) { title = ''; }
        var element = document.createElement('span');
        element.className = cls;
        if (title) {
            element.title = title;
            element.setAttribute('aria-label', title);
        }
        return element;
    };
    Buttons.prototype.show = function () {
        this.f.classList.remove('hidden');
        this.ff.classList.remove('hidden');
        this.fff.classList.remove('hidden');
    };
    Buttons.prototype.hide = function () {
        this.f.classList.add('hidden');
        this.ff.classList.add('hidden');
        this.fff.classList.add('hidden');
    };
    return Buttons;
}());
var Access = (function () {
    function Access() {
        this.anchor = Buttons.createElement('btn center', 'access');
        this.select = document.createElement('select');
        this.select.id = 'access';
        this.select.classList.add('access');
        this.anchor.appendChild(this.select);
    }
    Access.prototype.init = function (test) {
        var e_2, _a;
        var _this = this;
        this.test = test;
        this.select.addEventListener('change', function (e) {
            _this.test.goTest(e.target.value);
        });
        try {
            for (var _b = __values(this.test.order), _c = _b.next(); !_c.done; _c = _b.next()) {
                var name_1 = _c.value;
                var option = document.createElement('option');
                option.setAttribute('value', name_1);
                option.classList.add('access');
                option.textContent = name_1;
                this.select.appendChild(option);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this.update();
    };
    Access.prototype.update = function () {
        this.select.value = this.test.currentTest().name;
    };
    return Access;
}());
exports.forwardBtn = new Buttons('next');
exports.backwardBtn = new Buttons('previous');
exports.access = new Access();
function addListener(button, method) {
    button.addEventListener('click', method);
    button.addEventListener('keyup', function (e) {
        if (e.key === 'Enter') {
            method(e);
        }
    });
}
function addListeners(test) {
    var _this = this;
    addListener(exports.backwardBtn.f, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, test.cycleTests(false)];
            case 1: return [2, _a.sent()];
        }
    }); }); });
    addListener(exports.backwardBtn.ff, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, test.cycleUnchangedTests(false)];
            case 1: return [2, _a.sent()];
        }
    }); }); });
    addListener(exports.backwardBtn.fff, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, test.cycleNewTests(false)];
            case 1: return [2, _a.sent()];
        }
    }); }); });
    addListener(exports.forwardBtn.f, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, test.cycleTests(true)];
            case 1: return [2, _a.sent()];
        }
    }); }); });
    addListener(exports.forwardBtn.ff, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, test.cycleUnchangedTests(true)];
            case 1: return [2, _a.sent()];
        }
    }); }); });
    addListener(exports.forwardBtn.fff, function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, test.cycleNewTests(true)];
            case 1: return [2, _a.sent()];
        }
    }); }); });
}
function updateAccess() {
    exports.access.update();
}
exports.updateAccess = updateAccess;
function init(test) {
    addListeners(test);
    var div = document.createElement('div');
    div.classList.add('btns');
    document.body.appendChild(div);
    div.appendChild(exports.backwardBtn.span);
    exports.backwardBtn.show();
    exports.access.init(test);
    div.appendChild(exports.access.anchor);
    var up = Buttons.createElement('btn center', 'selection');
    up.textContent = 'Selection';
    up.setAttribute('tabindex', '0');
    addListener(up, function () {
        test.saveTest(test.getTest());
        window.location.assign('selection.html');
    });
    div.appendChild(up);
    div.appendChild(exports.forwardBtn.span);
    exports.forwardBtn.show();
}
exports.init = init;
